import { useState, FormEvent } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d7dfk96m3fsfopf23rm0';

const Contato = () => {
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const mensagem = (form.elements.namedItem('mensagem') as HTMLTextAreaElement)?.value || '';
    if (mensagem.length > 500) return;

    setStatus('sending');
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      data.append(key, value as string);
    });

    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setStatus('success');
        form.reset();
        setCharCount(0);
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contato" className="bg-[#111111] py-24 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left: Info */}
          <div>
            <span className="inline-flex items-center gap-2 text-[#f5a623] text-xs font-bold tracking-widest uppercase mb-6">
              <span className="w-8 h-px bg-[#f5a623]"></span>
              Entre em Contato
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6">
              Vamos Voar<br />
              <span className="text-[#f5a623]">Juntos?</span>
            </h2>
            <p className="text-white/55 text-base leading-relaxed mb-10">
              Solicite um orçamento sem compromisso. Nossa equipe responde em até 2 horas durante o horário comercial. Atendemos toda a Grande São Paulo.
            </p>

            {/* Contact Cards */}
            <div className="flex flex-col gap-4 mb-10">
              <a
                href="https://wa.me/5511954283481"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 bg-[#1a1a1a] border border-white/8 hover:border-[#25D366]/40 rounded-xl p-4 transition-all duration-200 cursor-pointer group"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#25D366]/15 rounded-xl flex-shrink-0 group-hover:bg-[#25D366]/25 transition-colors">
                  <i className="ri-whatsapp-line text-[#25D366] text-xl"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">WhatsApp</div>
                  <div className="text-white/50 text-sm">(11) 95428-3481</div>
                </div>
                <i className="ri-arrow-right-line text-white/30 ml-auto text-lg"></i>
              </a>

              <a
                href="mailto:dronefacilsp@gmail.com"
                className="flex items-center gap-4 bg-[#1a1a1a] border border-white/8 hover:border-[#f5a623]/40 rounded-xl p-4 transition-all duration-200 cursor-pointer group"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#f5a623]/15 rounded-xl flex-shrink-0 group-hover:bg-[#f5a623]/25 transition-colors">
                  <i className="ri-mail-line text-[#f5a623] text-xl"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">E-mail</div>
                  <div className="text-white/50 text-sm">dronefacilsp@gmail.com</div>
                </div>
                <i className="ri-arrow-right-line text-white/30 ml-auto text-lg"></i>
              </a>

              <div className="flex items-center gap-4 bg-[#1a1a1a] border border-white/8 rounded-xl p-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/8 rounded-xl flex-shrink-0">
                  <i className="ri-map-pin-line text-white/60 text-xl"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">Endereço</div>
                  <div className="text-white/50 text-sm">Rua do Lago, 237 — São Paulo, SP</div>
                </div>
              </div>

              <div className="flex items-center gap-4 bg-[#1a1a1a] border border-white/8 rounded-xl p-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/8 rounded-xl flex-shrink-0">
                  <i className="ri-time-line text-white/60 text-xl"></i>
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">Horário de Atendimento</div>
                  <div className="text-white/50 text-sm">Seg–Sex: 8h–18h | Sáb: 9h–13h</div>
                </div>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <a
              href="https://wa.me/5511954283481?text=Ol%C3%A1%2C%20tenho%20interesse%20nos%20servi%C3%A7os%20de%20drone"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-base px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer w-full justify-center"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Chamar no WhatsApp Agora
            </a>
          </div>

          {/* Right: Form */}
          <div className="bg-[#161616] border border-white/8 rounded-2xl p-8">
            <h3 className="text-white text-xl font-bold mb-2">Solicite um Orçamento</h3>
            <p className="text-white/50 text-sm mb-7">Preencha o formulário e retornaremos em breve.</p>

            {status === 'success' ? (
              <div className="flex flex-col items-center justify-center py-12 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-[#25D366]/20 rounded-full mb-4">
                  <i className="ri-check-line text-[#25D366] text-3xl"></i>
                </div>
                <div className="text-white font-bold text-lg mb-2">Mensagem Enviada!</div>
                <div className="text-white/50 text-sm">Entraremos em contato em breve. Obrigado!</div>
                <button
                  onClick={() => setStatus('idle')}
                  className="mt-6 text-[#f5a623] text-sm font-medium cursor-pointer hover:underline whitespace-nowrap"
                >
                  Enviar outra mensagem
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col gap-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="text-white/60 text-xs font-medium mb-1.5 block">Nome *</label>
                    <input
                      type="text"
                      name="nome"
                      required
                      placeholder="Seu nome completo"
                      className="w-full bg-[#1e1e1e] border border-white/10 text-white text-sm placeholder-white/30 rounded-xl px-4 py-3 focus:outline-none focus:border-[#f5a623]/50 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="text-white/60 text-xs font-medium mb-1.5 block">Telefone *</label>
                    <input
                      type="tel"
                      name="telefone"
                      required
                      placeholder="(11) 99999-9999"
                      className="w-full bg-[#1e1e1e] border border-white/10 text-white text-sm placeholder-white/30 rounded-xl px-4 py-3 focus:outline-none focus:border-[#f5a623]/50 transition-colors"
                    />
                  </div>
                </div>

                <div>
                  <label className="text-white/60 text-xs font-medium mb-1.5 block">E-mail *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="seu@email.com"
                    className="w-full bg-[#1e1e1e] border border-white/10 text-white text-sm placeholder-white/30 rounded-xl px-4 py-3 focus:outline-none focus:border-[#f5a623]/50 transition-colors"
                  />
                </div>

                <div>
                  <label className="text-white/60 text-xs font-medium mb-1.5 block">Serviço de Interesse</label>
                  <select
                    name="servico"
                    className="w-full bg-[#1e1e1e] border border-white/10 text-white text-sm rounded-xl px-4 py-3 focus:outline-none focus:border-[#f5a623]/50 transition-colors cursor-pointer"
                  >
                    <option value="">Selecione um serviço</option>
                    <option value="Acompanhamento de Obras">Acompanhamento de Obras</option>
                    <option value="Fotos para Imobiliárias">Fotos para Imobiliárias</option>
                    <option value="Cobertura de Eventos">Cobertura de Eventos</option>
                    <option value="Mapeamento Aéreo">Mapeamento Aéreo</option>
                    <option value="Outro">Outro</option>
                  </select>
                </div>

                <div>
                  <label className="text-white/60 text-xs font-medium mb-1.5 block">
                    Mensagem * <span className={`ml-1 ${charCount > 450 ? 'text-red-400' : 'text-white/30'}`}>{charCount}/500</span>
                  </label>
                  <textarea
                    name="mensagem"
                    required
                    rows={4}
                    maxLength={500}
                    placeholder="Descreva seu projeto ou necessidade..."
                    onChange={(e) => setCharCount(e.target.value.length)}
                    className="w-full bg-[#1e1e1e] border border-white/10 text-white text-sm placeholder-white/30 rounded-xl px-4 py-3 focus:outline-none focus:border-[#f5a623]/50 transition-colors resize-none"
                  />
                </div>

                {status === 'error' && (
                  <div className="text-red-400 text-sm bg-red-400/10 border border-red-400/20 rounded-xl px-4 py-3">
                    Erro ao enviar. Tente novamente ou entre em contato pelo WhatsApp.
                  </div>
                )}

                <button
                  type="submit"
                  disabled={status === 'sending'}
                  className="w-full flex items-center justify-center gap-2 bg-[#f5a623] hover:bg-[#e09510] disabled:opacity-60 text-black font-bold text-sm py-4 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  {status === 'sending' ? (
                    <>
                      <i className="ri-loader-4-line animate-spin text-base"></i>
                      Enviando...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-line text-base"></i>
                      Enviar Mensagem
                    </>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contato;
